import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { matchPath } from 'react-router-dom'

import { globalDefinitions } from './defined-translations'

type RouteMeta = {
  path: string
  meta: {
    title: string
  }
}

const routeMeta = (name?: string): RouteMeta[] => [
  {
    path: '/',
    meta: {
      title: i18n._(globalDefinitions.greeting, {
        value: name,
      }),
    },
  },
  {
    path: '/home',
    meta: {
      title: i18n._(globalDefinitions.greeting, {
        value: name,
      }),
    },
  },
  {
    path: '/documents/*',
    meta: {
      title: t({
        id: 'route.documents',
        message: 'Je documenten',
      }),
    },
  },
  {
    path: '/message/*',
    meta: {
      title: t({
        id: 'route.message',
        message: 'Berichten',
      }),
    },
  },
  {
    path: '/task/*',
    meta: {
      title: t({
        id: 'route.task',
        message: 'Taken',
      }),
    },
  },
  {
    path: '/care',
    meta: {
      title: t({
        id: 'route.care',
        message: 'Welzijn',
      }),
    },
  },
  {
    path: '/timeline',
    meta: {
      title: t({
        id: 'route.timeline',
        message: 'Je agenda',
      }),
    },
  },
  {
    path: '/timeline/appointment/*',
    meta: {
      title: t({
        id: 'route.timeline.appointment',
        message: 'Je agenda',
      }),
    },
  },
  {
    path: '/timeline/encounter/*',
    meta: {
      title: t({
        id: 'route.timeline.encounter',
        message: 'Je agenda',
      }),
    },
  },
  {
    path: '/timeline/activity/*',
    meta: {
      title: t({
        id: 'route.timeline.activity',
        message: 'Je agenda',
      }),
    },
  },
  {
    path: '/profile',
    meta: {
      title: t({
        id: 'route.profile',
        message: 'Je profiel',
      }),
    },
  },
  {
    path: '/profile/*',
    meta: {
      title: t({
        id: 'route.profile.information',
        message: 'Je profiel',
      }),
    },
  },
]

function getRouteMeta(path: string, name?: string): RouteMeta['meta'] | undefined {
  const meta = routeMeta(name)

  const directMatch = meta.find((value) => matchPath(value.path, path))
  if (directMatch) return directMatch.meta

  // Tenant-scoped routes are mounted under `/:tenant/*` in `router.tsx`,
  // but meta definitions are kept tenant-agnostic (e.g. `/documents/*`).
  // Example: `/mijnziekenhuis/documents/123` -> `/documents/123`
  const segments = path.split('/').filter(Boolean)
  const pathWithoutTenant = `/${segments.slice(1).join('/')}`
  const normalizedPath = pathWithoutTenant === '/' ? '/' : pathWithoutTenant

  const normalizedMatch = meta.find((value) => matchPath(value.path, normalizedPath))
  return normalizedMatch?.meta
}

export { getRouteMeta }
